import { useLocation } from "react-router";
import { useSpaNavigate } from "shared-ui";

import { CONNECT_APP_ROUTE_PATHS, NAVIGATION_PATHS } from "../../components/constants";
import { getAirOriginPath } from "../../utils/air-origin-path";

/**
 * Returns a function that navigates the customer back to wherever they entered the AIR flow from
 * (Get Started, Additional Funding tasks, or the in-review screen) based on the current pathname.
 */
export const useAirBackNavigation = () => {
  const { navigate } = useSpaNavigate("FundingApp");
  const { pathname } = useLocation();

  return () => {
    const airOrigin = getAirOriginPath(pathname);
    switch (airOrigin) {
      case CONNECT_APP_ROUTE_PATHS.ADDITIONAL_FUNDING:
        return navigate(NAVIGATION_PATHS.ADDITIONAL_FUNDING_TASKS);
      case CONNECT_APP_ROUTE_PATHS.GET_STARTED:
        return navigate(NAVIGATION_PATHS.GET_STARTED);
      default:
        return navigate(NAVIGATION_PATHS.ADDITIONAL_INFORMATION_REQUEST);
    }
  };
};
